<template>
  <div>
    <div class="opo02">
      <span class="opo03">系统日志</span>
<!--      <span class="opo04"> 系统日志</span>-->
    </div>
<!--    <div class="opo01">-->
<!--      <div class="djt30">-->
<!--        <div class="djt31">-->
<!--          <input v-model="searchs" type="text" placeholder="输入名称进行搜索" placeholder-class="djt32" class="djt33">-->
<!--          <img @click="seas" src="@/assets/images/sea01.png" alt="" class="djt34">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="djt05" style="margin-top: 10px">
      <div class="djt06">
        <div class="djt26z" style="width: 80%;">访问地址</div>
        <div class="djt26z" style="width: 20%">日期</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt27z" style="width: 80%;text-align: start" :title="item.url"><a target="_blank" style="text-decoration:underline;" :href="item.url">{{item.url}}</a></div>
            <div class="djt27z" style="width: 20%" :title="item.ctime">{{item.ctime}}</div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djgrz",
    data(){
      return{
        searchs:'',
        isModel:false,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        name:'',
        num:'',
        spec:'',
        imageUrl: '',
        lsItem:[],
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      let data = {
        page:1,
        pageSize:me.pageSize,
      }
      httpUser.getlogfilelist(data).then(res => {
        console.log(res);
        me.data = res.data;
        me.loading = false;
      })
    },
    methods:{
      toPage(e){//分页
        me.loading = true;
        let data = {
          page:e,
          pageSize:me.pageSize,
        }
        me.page = e;
        httpUser.getlogfilelist(data).then(res => {
          me.data = res.data;
          me.loading = false;
        })
      },
      cancel(){//添加框点击返回
        me.isModel = false;
      },
      back(){
        me.$router.push({path:'/djgrz',query:{}});
      },
    }
  }
</script>

<style scoped>
@import "djgrz.css";
</style>